import React, {useContext, useEffect, useRef, useState} from "react";
import useFetch from "use-http";
import moment from "moment";
import _ from "lodash";
import {useTranslation} from "react-i18next";
import classNames from "classnames";
import {Button} from "antd";
// get our fontawesome imports
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBullseye, faRedoAlt, faTrash,} from "@fortawesome/free-solid-svg-icons";
import IconPin from "./images/IconPin";
import LazySticker from "./component-message/LazySticker";
import UIMessageLink from "./component-message/UIMessageLink";
import UIMessageReply from "./component-message/UIMessageReply";
import UIMessageImage from "./component-message/UIMessageImage";
import UIMessageVideo from "./component-message/UIMessageVideo";
import UIMessageSound from "./component-message/UIMessageSound";
import UIMessageAudio from "./component-message/UIMessageAudio";
import UIMeetingRecord from "./component-message/UIMeetingRecord";
import UIMessageCenterFile from "./component-message/UIMessageCenterFile";
import UIMessageMention from "./component-message/UIMessageMention";
import {expAudio, expEmail, expImgges, expURL, expVideo, messageTypes, sendStatus, Service,} from "./ChatConstants";
import styles from "./UIMessage.module.scss";
import profil from "./images/UIChatRoom-profil2.png";
import checkIn from "./images/check-in.svg";
import pin from "./images/pin.svg";
import {getUrlHttp} from "src/service/util.service";
import {ChatContext} from "src/pages/context/Chat.context";
import {supportViewer} from "src/pages/filePage/properies.file";

// import { member } from "src/service/group.service";

function handleOpenLink(event: any) {
  if (event && event.preventDefault) {
    event.preventDefault();
  }
  window.open(event.target.href, "_system");
  return;
}

function UIMessage(props: any) {
  let msgObj = props.msgObj;
  const { t } = useTranslation();
  const regexURL = new RegExp(expURL);
  const regexEmail = new RegExp(expEmail);
  const chatCtx: any = useContext(ChatContext);
  const [graphDetail, setGraphDetail]: any = useState({});
  const [onSelect, setOnSelect]: any = useState(false);
  const refMessageControl: any = useRef(null);
  const apiOpenGraph = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + Service.CenterOpengraph
  );
  let isAnother = 1;
  let username: any;
  let profile: any;
  let removedUser: any;
  let ownerGroup: any;
  const isSelect = props.isSelect?.select;
  const defaultSelect = props.isSelect?.default;
  const messageStatus = msgObj?.messageStatus?.toLowerCase();

  if (props.userId === msgObj?.userId) isAnother = 2;

  if (props?.userDetail?.length > 0) {
    if (props?.userDetail?.[0]?.user) {
      username = props?.userDetail?.[0]?.user?.username;
      profile = props?.userDetail?.[0]?.user?.profile;
      msgObj = Object.assign(msgObj, { username: username, profile: profile });
    } else {
      username = t("Unknown");
      profile = null;
      msgObj = Object.assign(msgObj, { username: username, profile: profile });
    }
  } else {
    username = t("Unknown");
    profile = null;
    msgObj = Object.assign(msgObj, { username: username, profile: profile });
  }

  const getMessageType = () => {
    if (msgObj?.messageType?.toLowerCase() === messageTypes?.CenterFlie) {
      let filetype = messageTypes?.CenterFlie;
      if (msgObj?.messageDetails?.fileDetails) {
        filetype = msgObj?.messageDetails?.fileDetails[0]?.fileType;
      }

      if (supportViewer.images.indexOf(filetype) > -1) {
        return messageTypes.Image;
      } else if (supportViewer.video.indexOf(filetype) > -1) {
        return messageTypes.Video;
      } else if (supportViewer.audio.indexOf(filetype) > -1) {
        return messageTypes.Audio;
      } else {
        return messageTypes.CenterFlie;
      }
    } else {
      return msgObj?.messageType?.toLowerCase();
    }
  };
  const messageType = getMessageType();
  const stickerDetail =
    messageType === messageTypes.Sticker ? msgObj?.messageDetails : [];

  const handleClickSelect = async (
    messageId: string,
    messageType: string,
    selectType: any
  ) => {
    if (!isSelect) return true;
    if (
      (messageType === messageTypes.Image ||
        messageType === messageTypes.Sticker ||
        messageType === messageTypes.Sound) &&
      selectType === sendStatus.Forward
    )
      return true;
    //@ts-ignore
    if (document.getElementById("check_" + messageId).checked) {
      //@ts-ignore
      document.getElementById("check_" + messageId).checked = false;
      setOnSelect(false);
      props.handleCountSelect(false);
    } else {
      //@ts-ignore
      document.getElementById("check_" + messageId).checked = true;
      setOnSelect(true);
      props.handleCountSelect(true);
    }
  };

  const _handleClick = (event: any) => {
    const wasOutside = !(event.target.contains === props.refControl.current);
    if (wasOutside && props.isOpenControl)
      props.setOpenControl({ isOpen: false });
  };

  const handleSelectedUser = (userID: string) => {
    if (chatCtx.userSelectedId === null || chatCtx.userSelectedId !== userID) {
      chatCtx.setSameUserDetail(false);
    } else if (chatCtx.userSelectedId === userID) {
      chatCtx.setSameUserDetail(true);
    }
    if (chatCtx.userSelectedId !== userID) {
      chatCtx.setUserSelectedId(userID);
      chatCtx.setShowUserDetail(true);
    } else {
      chatCtx.setUserSelectedId({});
      chatCtx.setShowUserDetail(false);
    }

    chatCtx.setShowUserList(false);
  };

  const _handleContextMenu = (event: any) => {
    event.preventDefault();
    props.setOpenRecordAudio(false);
    props.setOpenSticker(false);
    props.setOpenControl({ isOpen: true, data: msgObj });
    const clickX = event.clientX;
    const clickY = event.clientY;
    const screenW = window.innerWidth;
    const screenH = window.innerHeight;
    const rootW = props.refControl.current.offsetWidth;
    const rootH = props.refControl.current.offsetHeight;
    const right = screenW - clickX > rootW;
    const left = !right;
    const top = screenH - clickY > rootH;
    const bottom = !top;
    if (right) {
      props.refControl.current.style.left = `${clickX + 5}px`;
    }
    if (left) {
      props.refControl.current.style.left = `${clickX - rootW - 5}px`;
    }
    if (top) {
      props.refControl.current.style.top = `${clickY + 5}px`;
    }
    if (bottom) {
      props.refControl.current.style.top = `${clickY - rootH - 5}px`;
    }
  };

  useEffect(() => {
    // when mounted
    if (isSelect && msgObj?.messageId === defaultSelect) {
      //@ts-ignore
      document.getElementById("check_" + defaultSelect).checked = true;
      setOnSelect(true);
      props.handleCountSelect(true);
    }
    if (!isSelect && document.getElementById("check_" + msgObj?.messageId)) {
      //@ts-ignore
      document.getElementById("check_" + msgObj?.messageId).checked = false;
      setOnSelect(false);
    }
  }, [isSelect]);

  useEffect(() => {
    // when mounted
    if (
      refMessageControl.current !== null &&
      !isSelect &&
      msgObj.messageStatus !== sendStatus.Sending
    ) {
      refMessageControl.current.addEventListener("click", _handleClick);
      refMessageControl.current.addEventListener(
        "contextmenu",
        _handleContextMenu
      );
    }
    return () => {
      //remove event when will unmount
      if (
        refMessageControl.current !== null &&
        !isSelect &&
        msgObj.messageStatus !== sendStatus.Sending
      ) {
        refMessageControl.current.removeEventListener("click", _handleClick);
        refMessageControl.current.removeEventListener(
          "contextmenu",
          _handleContextMenu
        );
      }
    };
  }, [refMessageControl.current, _handleClick, _handleContextMenu]);

  useEffect(() => {
    const handleLinkOpenGraph = async (url: any) => {
      try {
        let responseData;
        let msgBody = { url: url };
        responseData = await apiOpenGraph.post(msgBody);
        setGraphDetail(responseData);
      } catch (error) {
        console.warn("Error handleLinkOpenGraph : ", error);
      }
    };

    if (
      messageType === messageTypes.Link &&
      messageStatus.toLowerCase() !== sendStatus.Unsend.toLowerCase()
    ) {
      const url =
        msgObj?.messageText.match(regexURL)?.[0] || msgObj?.messageText;
      handleLinkOpenGraph(url);
    }
  }, []);

  const dateTimePost = (postTime: any) => {
    if ( props.lang === "th" ) {
      return moment(postTime).format("HH:mm น.")
    } else {
      return moment(postTime).format("LT")
    }
  }

  // Start check messageType 'unsend' in chat.
  if (messageStatus.toLowerCase() === sendStatus.Unsend.toLowerCase()) {
    return (
      <>
        <div
          ref={props.refNewMessage}
          className={styles.groupUnsend}
          onClick={() => {
            if (!props.isBlockSelect) {
              handleClickSelect(
                msgObj?.messageId,
                msgObj?.messageType,
                props.isSelect.type
              );
            }
            props.setOpenControl({ isOpen: false });
            props.setOpenSticker(false);
            props.setOpenRecordAudio(false);
          }}
          style={{ width: "100%" }}
        >
          {props?.showDate && (
            <div className={classNames("chat-caption", styles.dateText)}>
              {props.showDate}
            </div>
          )}
          <div style={{ width: "100%", display: "flex" }}>
            <div
              className={styles.msgUnsend}
              id={
                msgObj?.messageRefId ? msgObj?.messageRefId : msgObj?.messageId
              }
              style={{ width: "100%" }}
            >
              <p className={classNames("chat-caption", styles.textUn)}>
                {messageStatus.toLowerCase() ===
                  sendStatus.Unsend.toLowerCase() &&
                  (isAnother > 1
                    ? t("You unsent a message")
                    : username + " " + t("unsent a message"))}
              </p>
            </div>
            <div
              className={styles.selectMessageUn}
              style={{
                display:
                  isSelect &&
                  props.isSelect.type.toLowerCase() ===
                    sendStatus.Delete.toLowerCase()
                    ? "block"
                    : "none",
              }}
            >
              <input
                type="checkbox"
                disabled={props.isBlockSelect}
                id={"check_" + msgObj?.messageId}
                name="selectMessage"
                value={msgObj?.messageId + "_" + msgObj?.userId}
                onClick={() => {
                  if (isSelect && !props.isBlockSelect) {
                    handleClickSelect(
                      msgObj?.messageId,
                      msgObj?.messageType,
                      props.isSelect.type
                    );
                  } else if (isSelect && props.isBlockSelect && onSelect) {
                    handleClickSelect(
                      msgObj?.messageId,
                      msgObj?.messageType,
                      props.isSelect.type
                    );
                  }
                }}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
  // Start check messageType 'check_in, join_group, leave_group' and 'unsend' in chat.
  if (
    messageType === messageTypes.CheckIn.toLowerCase() ||
    messageType === messageTypes.JoinGroup.toLowerCase() ||
    messageType === messageTypes.LeaveGroup.toLowerCase() ||
    messageType === messageTypes.KickGroup.toLowerCase() ||
    messageType === messageTypes.Invited.toLowerCase()
  ) {
    if (
      messageType === messageTypes.JoinGroup.toLowerCase() ||
      messageType === messageTypes.KickGroup.toLowerCase()
    ) {
      if (msgObj?.messageText) {
        let messageText = msgObj?.messageText;
        let lastIndex = messageText?.lastIndexOf("_");
        let joinUserId = msgObj?.messageText?.substring(0, lastIndex);
        let joinUserName = msgObj?.messageText?.substring(
          lastIndex + 1,
          msgObj?.messageText?.length
        );
        removedUser = joinUserName;
        let userDetail = props?.tempMember?.filter((item: any) => {
          return item?.userId?.indexOf(joinUserId) !== -1;
        });
        if (userDetail) {
          username = userDetail?.[0]?.user?.username || joinUserName;
        }
        ownerGroup = props?.tempMember?.filter((item: any) => {
          return item?.userId?.indexOf(msgObj?.userId) !== -1;
        });
      }
    }
    return (
      <>
        <div
          ref={props.refNewMessage}
          className={messageType}
          onClick={() => {
            props.setOpenControl({ isOpen: false });
            props.setOpenSticker(false);
            props.setOpenRecordAudio(false);
            if (isSelect && !props.isBlockSelect) {
              handleClickSelect(
                msgObj?.messageId,
                msgObj?.messageType,
                props.isSelect.type
              );
            } else if (isSelect && props.isBlockSelect && onSelect) {
              handleClickSelect(
                msgObj?.messageId,
                msgObj?.messageType,
                props.isSelect.type
              );
            }
          }}
          style={{ width: "100%" }}
        >
          {props?.showDate && (
            <div className={classNames("chat-caption", styles.dateText)}>
              {props.showDate}
            </div>
          )}
          <div style={{ width: "100%", display: "flex" }}>
            <div
              className={styles.msgChectIn}
              id={
                msgObj?.messageRefId ? msgObj?.messageRefId : msgObj?.messageId
              }
              style={{ width: "100%" }}
            >
              {dateTimePost(msgObj?.messageTime)}
              <p className={classNames("chat-caption", styles.textUn)}>
                {messageType === messageTypes.CheckIn && (
                  <img src={checkIn} alt="preload" width="14px" height="14px" />
                )}
                {messageType === messageTypes.JoinGroup && (
                  <img
                    src={pin}
                    alt="preload"
                    style={{ paddingRight: 5 }}
                    width="14px"
                    height="14px"
                  />
                )}
                {messageType === messageTypes.JoinGroup &&
                  username + " " + t("joined the group")}
                {messageType === messageTypes.LeaveGroup &&
                  " " + username + " " + t("left the group")}
                {messageType === messageTypes.KickGroup &&
                  ownerGroup?.[0]?.user?.username +
                    " " +
                    t("removed") +
                    " " +
                    removedUser +
                    " " +
                    t("from the group")}
                {messageType === messageTypes.CheckIn &&
                  (isAnother > 1
                    ? t("You arrived at") + " " + msgObj?.messageText
                    : " " +
                      username +
                      " " +
                      t("arrived at") +
                      " " +
                      msgObj?.messageText)}
                {messageType === messageTypes.Invited &&
                  (isAnother > 1
                    ? t("You invited") +
                      " " +
                      props?.invitedListStr +
                      " " +
                      t("to the group")
                    : username +
                      " " +
                      t("invite") +
                      " " +
                      props?.invitedListStr +
                      " " +
                      t("to the group"))}
              </p>
            </div>
            <div
              className={styles.selectMessageUn}
              style={{
                display:
                  isSelect &&
                  props.isSelect.type.toLowerCase() ===
                    sendStatus.Delete.toLowerCase()
                    ? "block"
                    : "none",
              }}
            >
              <input
                type="checkbox"
                disabled={props.isBlockSelect}
                id={"check_" + msgObj?.messageId}
                name="selectMessage"
                value={msgObj?.messageId + "_" + msgObj?.userId}
                onClick={() => {
                  if (isSelect && !props.isBlockSelect) {
                    handleClickSelect(
                      msgObj?.messageId,
                      msgObj?.messageType,
                      props.isSelect.type
                    );
                  } else if (isSelect && props.isBlockSelect && onSelect) {
                    handleClickSelect(
                      msgObj?.messageId,
                      msgObj?.messageType,
                      props.isSelect.type
                    );
                  }
                }}
              />
            </div>
          </div>
        </div>
      </>
    );
  }

  // Start check messageType 'center_file' in chat.
  if (
    messageType === messageTypes.CenterFlie &&
    !msgObj?.messageDetails?.fileDetails
  ) {
    // console.log(msgObj?.messageDetails);
    const fileDetails = !_.isEmpty(msgObj?.messageDetails)
      ? msgObj?.messageDetails
      : {};
    const regexImgges = new RegExp(expImgges);
    const regexVideo = new RegExp(expVideo);
    const regexAudio = new RegExp(expAudio);
    return (
      <>
        <div
          ref={props.refNewMessage}
          className={styles.groupUnsend}
          onClick={() => {
            if (isSelect && !props.isBlockSelect) {
              handleClickSelect(
                msgObj?.messageId,
                msgObj?.messageType,
                props.isSelect.type
              );
            } else if (isSelect && props.isBlockSelect && onSelect) {
              handleClickSelect(
                msgObj?.messageId,
                msgObj?.messageType,
                props.isSelect.type
              );
            }
            if (!isSelect) {
              props.setOpenControl({ isOpen: false });
              props.setOpenSticker(false);
              props.setOpenRecordAudio(false);
              if (fileDetails?.type?.match(regexImgges))
                props.handlePreviewFile(
                  "image",
                  fileDetails?.title,
                  fileDetails?.path,
                  "old"
                );
              if (fileDetails?.type?.match(regexVideo))
                props.handlePreviewFile(
                  "video",
                  fileDetails?.title,
                  fileDetails?.path,
                  ""
                );
              if (fileDetails?.type?.match(regexAudio))
                props.handlePreviewFile(
                  "audio",
                  fileDetails?.title,
                  fileDetails?.path,
                  ""
                );
            }
          }}
          style={{ width: "100%" }}
        >
          {props?.showDate && (
            <div className={classNames("chat-caption", styles.dateText)}>
              {props.showDate}
            </div>
          )}
          <div style={{ width: "100%", display: "flex" }}>
            <div
              className={styles.msgUnsend}
              id={
                msgObj?.messageRefId ? msgObj?.messageRefId : msgObj?.messageId
              }
              style={{ width: "100%" }}
            >
              <p
                className={classNames("chat-caption", styles.textUn)}
                style={{ cursor: "pointer" }}
              >
                {messageType === messageTypes.CenterFlie && (
                  <i
                    className="far fa-file-alt"
                    style={{ fontSize: "medium", color: "#9B9B9B" }}
                  ></i>
                )}
                {messageType === messageTypes.CenterFlie &&
                  (isAnother > 1
                    ? " " + t("You share") + " " + msgObj?.messageText
                    : " " +
                      username +
                      " " +
                      t("share") +
                      " " +
                      msgObj?.messageText)}
              </p>
            </div>
            <div
              className={styles.selectMessageUn}
              style={{
                display:
                  isSelect &&
                  props.isSelect.type.toLowerCase() ===
                    sendStatus.Delete.toLowerCase()
                    ? "block"
                    : "none",
              }}
            >
              <input
                type="checkbox"
                disabled={props.isBlockSelect}
                id={"check_" + msgObj?.messageId}
                name="selectMessage"
                value={msgObj?.messageId + "_" + msgObj?.userId}
                onClick={() => {
                  if (isSelect && !props.isBlockSelect) {
                    handleClickSelect(
                      msgObj?.messageId,
                      msgObj?.messageType,
                      props.isSelect.type
                    );
                  } else if (isSelect && props.isBlockSelect && onSelect) {
                    handleClickSelect(
                      msgObj?.messageId,
                      msgObj?.messageType,
                      props.isSelect.type
                    );
                  }
                }}
              />
            </div>
          </div>
        </div>
      </>
    );
  }

  // Start render Message type 'Text, Link'
  return (
    <div ref={props.refNewMessage} className={styles.messageRow}>
      {props?.showDate && (
        <div className={classNames("chat-caption", styles.dateText)}>
          {props.showDate}
        </div>
      )}
      <div
        className="msgCreate"
        tabIndex={0}
        id={msgObj?.messageRefId ? msgObj?.messageRefId : msgObj?.messageId}
        style={
          isAnother > 1
            ? { paddingRight: 0, width: "100%" }
            : { paddingLeft: 5, width: "100%" }
        }
        onClick={() => {
          props.setOpenControl({ isOpen: false });
          props.setOpenSticker(false);
          props.setOpenRecordAudio(false);
          if (isSelect && !props.isBlockSelect) {
            handleClickSelect(
              msgObj?.messageId,
              msgObj?.messageType,
              props.isSelect.type
            );
          } else if (isSelect && props.isBlockSelect && onSelect) {
            handleClickSelect(
              msgObj?.messageId,
              msgObj?.messageType,
              props.isSelect.type
            );
          }
        }}
      >
        <div style={{ display: "flex", minHeight: "50px", width: "100%" }}>
          {/* Profile Image */}
          {isAnother === 1 && (
            <div
              className={styles.profileImg}
              onClick={() => {
                handleSelectedUser(props?.userDetail?.[0]?.userId);
              }}
            >
              <div
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "50%",
                  backgroundColor: "#b8b8b8",
                  backgroundPosition: "0",
                  backgroundImage: `url(${
                    props?.userDetail ? getUrlHttp(profile) : getUrlHttp(profil)
                  })`,
                  backgroundSize: "cover",
                }}
              ></div>
            </div>
          )}
          <div
            style={
              isAnother > 1
                ? { marginLeft: "auto", maxWidth: "calc(100% - 50px)" }
                : { overflow: "hidden", maxWidth: "calc(100% - 50px)" }
            }
          >
            {isAnother === 1 && (
              <div className={styles.boxProfileUserName}>
                <p className={classNames("chat-title", styles.profileUserName)}>
                  {username}
                </p>
              </div>
            )}
            {/* Body Message type 'Sticker' */}
            {messageType === messageTypes.Sticker && (
              <div
                className={
                  isAnother > 1
                    ? styles.boxMessageSticker2
                    : styles.boxMessageSticker1
                }
                ref={
                  messageStatus === sendStatus.Created.toLowerCase()
                    ? refMessageControl
                    : undefined
                }
              >
                <LazySticker
                  type={"message"}
                  key={msgObj?.messageId}
                  id={
                    stickerDetail?.type === "default"
                      ? stickerDetail?.stickerId
                      : stickerDetail?.transactionId +
                        "_" +
                        stickerDetail?.stickerId
                  }
                  src={msgObj?.messageText}
                />
              </div>
            )}

            {/* Body Message type 'CenterFlie' */}
            {messageType === messageTypes.CenterFlie && (
              <div
                className={
                  isAnother > 1 ? styles.boxMessageOut2 : styles.boxMessageOut1
                }
                ref={
                  msgObj?.messageStatus === sendStatus.Created.toLowerCase()
                    ? refMessageControl
                    : undefined
                }
              >
                <UIMessageCenterFile
                  tempKey={msgObj?.messageId}
                  messageStatus={
                    messageStatus === sendStatus.Sending.toLowerCase()
                      ? true
                      : false
                  }
                  isAnother={isAnother}
                  messageDetails={msgObj?.messageDetails}
                  messageURLlocal={msgObj?.messageURLlocal}
                  tempMsgId={msgObj?.messageId}
                  uploadProgress={
                    !msgObj?.messageDetails?.id ? props?.uploadProgress : []
                  }
                  setUploadProgress={props.setUploadProgress}
                />
              </div>
            )}

            {/* Body Message type 'Image' */}
            {messageType === messageTypes.Image && (
              <div
                className={
                  isAnother > 1 ? styles.boxMessageOut2 : styles.boxMessageOut1
                }
                ref={
                  msgObj?.messageStatus === sendStatus.Created.toLowerCase()
                    ? refMessageControl
                    : undefined
                }
              >
                <UIMessageImage
                  key={msgObj?.messageId}
                  handlePreviewImage={props.handlePreviewFile}
                  isAnother={isAnother}
                  msgObj={msgObj}
                  messageType={messageType}
                  messageURLlocal={
                    !_.isEmpty(msgObj?.messageURLlocal)
                      ? msgObj?.messageURLlocal
                      : null
                  }
                  messageDetails={msgObj?.messageDetails || null}
                />
              </div>
            )}

            {/* Body Message type 'Video' */}
            {messageType === messageTypes.Video && (
              <div
                className={
                  isAnother > 1 ? styles.boxMessageOut2 : styles.boxMessageOut1
                }
                ref={
                  msgObj?.messageStatus === sendStatus.Created.toLowerCase()
                    ? refMessageControl
                    : undefined
                }
              >
                <UIMessageVideo
                  key={msgObj?.messageId}
                  messageStatus={
                    messageStatus === sendStatus.Sending.toLowerCase()
                      ? true
                      : false
                  }
                  handlePreviewFile={props.handlePreviewFile}
                  isAnother={isAnother}
                  messageDetails={msgObj?.messageDetails}
                  messageURLlocal={msgObj?.messageURLlocal}
                  tempMsgId={msgObj?.messageId}
                  uploadProgress={
                    !msgObj?.messageDetails?.id ? props?.uploadProgress : []
                  }
                  setUploadProgress={props?.setUploadProgress}
                  msgObj={msgObj}
                />
              </div>
            )}

            {/* Body Message type 'Audio' */}
            {messageType === messageTypes.Audio && (
              <div
                className={
                  isAnother > 1 ? styles.boxMessageOut2 : styles.boxMessageOut1
                }
                ref={
                  msgObj?.messageStatus === sendStatus.Created.toLowerCase()
                    ? refMessageControl
                    : undefined
                }
              >
                <UIMessageAudio
                  key={msgObj?.messageId}
                  messageStatus={
                    messageStatus === sendStatus.Sending.toLowerCase()
                      ? true
                      : false
                  }
                  isAnother={isAnother}
                  messageDetails={msgObj?.messageDetails}
                  messageURLlocal={msgObj?.messageURLlocal}
                  tempMsgId={msgObj?.messageId}
                  uploadProgress={
                    !msgObj?.messageDetails?.id ? props?.uploadProgress : []
                  }
                  setUploadProgress={props.setUploadProgress}
                />
              </div>
            )}

            {/* Body Reply Message 'Text, Link' */}
            {msgObj?.messageReplyId &&
              messageType !== messageTypes.Image &&
              messageType !== messageTypes.Video && (
                <div
                  className={
                    isAnother > 1
                      ? styles.boxMessageOut2
                      : styles.boxMessageOut1
                  }
                  ref={
                    msgObj?.messageStatus === sendStatus.Created.toLowerCase()
                      ? refMessageControl
                      : undefined
                  }
                >
                  <UIMessageReply
                    msgObj={msgObj}
                    messageNew={msgObj}
                    graphDetail={graphDetail}
                    isAnother={isAnother}
                    tempMember={props.tempMember}
                    handleOpenLink={isSelect ? handleOpenLink : null}
                    handleSelectedUser={handleSelectedUser}
                    storageMessageList={props.storageMessageList}
                  />
                </div>
              )}

            {/* Body Message 'Text, Link, Sound' */}
            {!msgObj?.messageReplyId &&
              (messageType === messageTypes.Text ||
                messageType === messageTypes.Link ||
                messageType === messageTypes.CallEnded ||
                messageType === messageTypes.MissedCall ||
                messageType === messageTypes.MeetingRecord ||
                messageType === messageTypes.Sound) && (
                <div
                  className={classNames(
                    "chat-message",
                    !graphDetail?.videos
                      ? isAnother > 1
                        ? styles.msgStyle2
                        : styles.msgStyle1
                      : ""
                  )}
                  style={
                    graphDetail?.videos && isAnother > 1
                      ? { marginLeft: "auto" }
                      : undefined
                  }
                  ref={
                    msgObj?.messageStatus === sendStatus.Created.toLowerCase()
                      ? refMessageControl
                      : undefined
                  }
                >
                  {messageType === messageTypes.MeetingRecord ? (
                    <UIMeetingRecord
                      handlePreviewImage={props.handlePreviewFile}
                      username={username}
                      messageDetails={
                        !_.isEmpty(msgObj?.messageDetails)
                          ? msgObj?.messageDetails
                          : {}
                      }
                      isSelect={isSelect || false}
                      isAnother={isAnother}
                      key={msgObj?.messageId}
                    />
                  ) : messageType === messageTypes.Link ? (
                    <UIMessageLink
                      graphDetail={graphDetail}
                      text={msgObj?.messageText}
                      isSelect={isSelect || false}
                      isAnother={isAnother}
                      key={msgObj?.messageId}
                      msgObj={msgObj}
                      onClickMention={handleSelectedUser}
                    />
                  ) : messageType === messageTypes.Sound ? (
                    <UIMessageSound
                      isSelect={isSelect || false}
                      isReply={props.isReply}
                      isAnother={isAnother}
                      soundDetails={msgObj?.messageDetails?.soundDetails[0]}
                      key={msgObj?.messageId}
                    />
                  ) : (
                    <React.Fragment>
                      {msgObj?.mentionProperty &&
                      msgObj?.mentionProperty?.mentionList?.[0] !== null ? (
                        <UIMessageMention
                          key={msgObj?.messageId}
                          msgObj={msgObj}
                          onClickMention={handleSelectedUser}
                        />
                      ) : messageType === messageTypes.Text &&
                        msgObj?.messageText.match(regexEmail) ? (
                        <UIMessageEmail
                          msgText={msgObj?.messageText}
                          regexEmail={regexEmail}
                        />
                      ) : (
                        <span>
                          {messageType === messageTypes.CallEnded
                            ? t("Call ended") + " " + msgObj?.messageText
                            : messageType === messageTypes.MissedCall
                            ? t("Missed call")
                            : messageType === messageTypes.CallFail
                            ? t("No answer")
                            : msgObj?.messageText}
                        </span>
                      )}
                    </React.Fragment>
                  )}
                </div>
              )}
            {((messageType === messageTypes.Image &&
              msgObj?.messageDetails?.imageDetails?.length === 0) ||
              (messageType === messageTypes.Video &&
                msgObj?.messageDetails?.videoDetails?.length === 0)) && (
              <div
                className={classNames(
                  "chat-message",
                  !graphDetail?.videos
                    ? isAnother > 1
                      ? styles.msgStyle2
                      : styles.msgStyle1
                    : ""
                )}
                style={
                  graphDetail?.videos && isAnother > 1
                    ? { marginLeft: "auto" }
                    : undefined
                }
                ref={
                  msgObj?.messageStatus === sendStatus.Created.toLowerCase()
                    ? refMessageControl
                    : undefined
                }
              >
                <span
                  style={{
                    fontStyle: "italic",
                    color: "#5f5d5d",
                    fontWeight: "bold",
                  }}
                >
                  {t("This file has been deleted")}
                </span>
              </div>
            )}
          </div>
          {/* CheckBox select message' */}
          <div
            className={
              isAnother > 1 ? styles.selectMessage2 : styles.selectMessage1
            }
            style={{
              display: isSelect ? "block" : "none",
            }}
          >
            <input
              style={
                (messageType === messageTypes.Sound ||
                  messageType === messageTypes.Sticker) &&
                props.isSelect.type === sendStatus.Forward
                  ? { visibility: "hidden" }
                  : {}
              }
              disabled={props.isBlockSelect}
              type="checkbox"
              id={"check_" + msgObj?.messageId}
              name="selectMessage"
              value={msgObj?.messageId + "_" + msgObj?.userId}
              onClick={() => {
                if (isSelect && !props.isBlockSelect) {
                  handleClickSelect(
                    msgObj?.messageId,
                    msgObj?.messageType,
                    props.isSelect.type
                  );
                } else if (isSelect && props.isBlockSelect && onSelect) {
                  handleClickSelect(
                    msgObj?.messageId,
                    msgObj?.messageType,
                    props.isSelect.type
                  );
                }
              }}
            />
          </div>

          {/* Status send message' */}
          {!isSelect && isAnother > 1 && (
            <div className={styles.sendStatus}>
              {msgObj?.messageStatus.toLowerCase() ===
                sendStatus.Sending.toLowerCase() ||
              msgObj?.messageStatus.toLowerCase() ===
                sendStatus.SendFail.toLowerCase() ? (
                <FontAwesomeIcon
                  className="font-awesome"
                  icon={faBullseye}
                  style={{
                    color: "#0f4c82",
                    width: "0.7rem",
                    height: "0.7rem",
                  }}
                />
              ) : (
                //@ts-ignore
                <IconPin
                  width={"0.7rem"}
                  height={"0.7rem"}
                  style={{
                    fill: "#0f4c82",
                  }}
                />
              )}
            </div>
          )}
        </div>

        {/* Message Time */}
        <div style={{ display: "flex" }}>
          <div
            className={
              isAnother > 1 ? styles.sentTimeStyle2 : styles.sentTimeStyle1
            }
          >
            {msgObj?.messageStatus.toLowerCase() !==
              sendStatus.SendFail.toLowerCase() &&
              dateTimePost(msgObj?.messageTime)}
            {/* Button Send fail */}
            {msgObj?.messageStatus.toLowerCase() ===
              sendStatus.SendFail.toLowerCase() && (
              <Button
                onClick={() => props.handleReSave(msgObj)}
                style={
                  messageType === messageTypes.Image ||
                  messageType === messageTypes.Sound
                    ? { display: "none" }
                    : {}
                }
              >
                <FontAwesomeIcon
                  className="font-awesome"
                  icon={faRedoAlt}
                  style={{
                    color: "#0f4c82",
                    width: "15px",
                    height: "15px",
                  }}
                />
              </Button>
            )}
            {msgObj?.messageStatus.toLowerCase() ===
              sendStatus.SendFail.toLowerCase() && (
              <Button onClick={() => props.handleCancelSend(msgObj?.messageId)}>
                <FontAwesomeIcon
                  className="font-awesome"
                  icon={faTrash}
                  style={{
                    color: "#0f4c82",
                    width: "15px",
                    height: "15px",
                  }}
                />
              </Button>
            )}
          </div>
        </div>
      </div>{" "}
      {/* Close msgCreate */}
    </div>
  );
}

const UIMessageEmail = (props: any) => {
  const { msgText, regexEmail } = props;
  let arrtext = msgText?.split(" ");
  return (
    <div className="msg-mention-wrapper">
      {arrtext?.map((item: any) => {
        let isEmail = item.match(regexEmail);
        if (isEmail?.length > 0) {
          return <span className="msg-email">{item}</span>;
        } else {
          return <span> {item} </span>;
        }
      })}
    </div>
  );
};

export default React.memo(UIMessage);
